"use client";
import { useI18n } from "@wojo/localization";
import { LoadingAnimation } from "@wojo/ui";
import React, { PropsWithChildren, Suspense } from "react";
import styles from "./AccountLoader.module.scss";

export const AccountLoader: React.FC<PropsWithChildren> = ({ children }) => {
    const i18n = useI18n("account").account;
    return (
        <Suspense
            fallback={
                <div className={styles["account-loader"]}>
                    <LoadingAnimation text={i18n.accountLoadingLabel.l()} />
                </div>
            }
        >
            {children}
        </Suspense>
    );
};
